"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BalanceAdjustmentDto = /** @class */ (function () {
    function BalanceAdjustmentDto() {
    }
    return BalanceAdjustmentDto;
}());
exports.default = BalanceAdjustmentDto;
